import Carousel from './components/Carousel';
import SlideCarousel from './components/slide-carousel';
import FullscreenOverlay from 'marketing/components/FullscreenOverlay';
import EmailCaptureForm from 'marketing/components/EmailCaptureForm';
import Accordion from './components/Accordion';
import { trackEvent } from '@99designs/common/utils/platform';
import '@99designs/common/jquery-plugins/tooltip';

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('[data-carousel]')) {
        Carousel.create().start();
    }

    SlideCarousel.create();

    initialiseProModal();

    $('[data-tooltip]').tooltip();

    // FAQs
    Accordion.create();
});

function initialiseProModal() {
    const acquisitionSourceAttr = 'data-acquisition-source';
    const acquisitionSourceElement = document.querySelector(`[${acquisitionSourceAttr}]`);
    const acquisitionSource = acquisitionSourceElement
        ? acquisitionSourceElement.getAttribute(acquisitionSourceAttr)
        : 'agency-pro-page';

    new FullscreenOverlay({
        element: document.querySelector('[data-fullscreen-overlay-id="pro-form-modal"]'),
        options: {
            fixedViewport: true,
            onClose: () =>
                trackEvent('Dismissed Email Capture Form', {
                    acquisition_source: acquisitionSource,
                }),
            onOpen: () =>
                trackEvent('Viewed Email Capture Form', {
                    acquisition_source: acquisitionSource,
                }),
        },
    });
    initEmailCaptureForm();

    // This is requested by agency team to use the same title as the CTA
    updateProModalTitle();
}

function initEmailCaptureForm() {
    const proModalFormContainer = document.querySelector('[data-pro-modal]');

    if (!proModalFormContainer) {
        return;
    }

    new EmailCaptureForm(proModalFormContainer, {
        withRecaptcha: true,
        formName: 'pro_form',
    });
}

function updateProModalTitle() {
    const firstModalTrigger = document.querySelector(
        '[data-fullscreen-overlay-open="pro-form-modal"]'
    );

    if (firstModalTrigger) {
        const proModalTitle = document.querySelector('[data-pro-modal-title]');

        if (proModalTitle) {
            proModalTitle.textContent = firstModalTrigger.textContent;
        }
    }
}
